import React from 'react';
import { Tag } from "antd";
import { useTexts } from "../hooks/useTexts";

interface PrescriptionStatusProps {
    status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'COMMUNICATION_ERROR' | 'OTHER_PRODUCT_PURCHASED' | null;
}

const baseTagStyle: React.CSSProperties = {
    borderRadius: '8px',
    padding: '4px 12px',
    fontSize: '13px',
    fontWeight: 700,
    letterSpacing: '0.4px',
    borderWidth: '1.5px',
    borderStyle: 'solid',
};

const statusStyles: Record<string, React.CSSProperties> = {
    PENDING:                 { backgroundColor: '#FFFBEB', borderColor: '#EAB308', color: '#854D0E' },
    APPROVED:                { backgroundColor: '#F0FDF4', borderColor: '#22C55E', color: '#166534' },
    REJECTED:                { backgroundColor: '#FEF2F2', borderColor: '#EF4444', color: '#991B1B' },
    COMMUNICATION_ERROR:     { backgroundColor: '#FFF7ED', borderColor: '#F97316', color: '#9A3412' },
    OTHER_PRODUCT_PURCHASED: { backgroundColor: '#F5F3FF', borderColor: '#8B5CF6', color: '#5B21B6' },
};

const PrescriptionStatus: React.FC<PrescriptionStatusProps> = ({ status }) => {
    const { t } = useTexts();

    const style = { ...baseTagStyle, ...(status && statusStyles[status] ? statusStyles[status] : {}) };

    switch (status) {
        case 'PENDING':
            return <Tag style={style}>{t('status', 'pending')}</Tag>;
        case 'APPROVED':
            return <Tag style={style}>{t('status', 'approved')}</Tag>;
        case 'REJECTED':
            return <Tag style={style}>{t('status', 'rejected')}</Tag>;
        case 'COMMUNICATION_ERROR':
            return <Tag style={style}>{t('status', 'communicationError')}</Tag>;
        case 'OTHER_PRODUCT_PURCHASED':
            return <Tag style={style}>{t('status', 'otherProductPurchased')}</Tag>;
        default:
            return <Tag style={{ ...baseTagStyle, backgroundColor: '#F9FAFB', borderColor: '#9CA3AF', color: '#374151' }}>{status}</Tag>;
    }
};

export default PrescriptionStatus;
